// extracted by mini-css-extract-plugin
export var chip = "_e8-0";
export var filterDropdown = "_e8-5";
export var filterItem = "_e8-6";
export var icon = "_e8-1";
export var removeButton = "_e8-3";
export var removeIcon = "_e8-4";
export var separator = "_e8-2";